<!--
  The toast's live region (state/toast.svelte.ts): in the app once
  (App.svelte), always in the page so screen readers announce the toast put
  into it, whichever page raised it. A toast stays while hovered or focused.
-->
<script lang="ts">
  import { toast } from '../state/toast.svelte';
  import ErrorNotice from './ErrorNotice.svelte';
</script>

<div class="toast-region" role="alert" aria-live="assertive">
  {#if toast.message}
    <!-- svelte-ignore a11y_no_static_element_interactions (hover only holds the timer; the button dismisses) -->
    <div
      class="toast"
      onmouseenter={() => toast.hold()}
      onmouseleave={() => toast.release()}
      onfocusin={() => toast.hold()}
      onfocusout={(e) => {
        if (!(e.currentTarget as HTMLElement).contains(e.relatedTarget as Node | null)) toast.release();
      }}
    >
      <span class="toast-text"><ErrorNotice text={toast.message.text} link={toast.message.link} linkText={toast.message.linkText} /></span>
      {#if toast.message.action}<button class="toast-action" onclick={() => toast.act()}>{toast.message.action.label}</button>{/if}
      <button class="toast-x" aria-label="Dismiss" title="Dismiss" onclick={() => toast.dismiss()}>×</button>
    </div>
  {/if}
</div>

<style>
  .toast {
    display: flex;
    gap: 10px;
    align-items: flex-start;
  }
  .toast-text {
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .toast-x {
    border: 0;
    background: none;
    color: inherit;
    opacity: 0.7;
    font-size: 16px;
    line-height: 1;
    padding: 0 2px;
  }
  .toast-action {
    flex: none;
    border: 1px solid currentColor;
    border-radius: 5px;
    background: none;
    color: inherit;
    font-size: 12px;
    font-weight: 650;
    padding: 1px 9px;
  }
  .toast-action:focus-visible {
    outline-color: var(--bg);
  }
  .toast-x:hover {
    opacity: 1;
  }
  .toast-x:focus-visible {
    outline-color: var(--bg);
  }
</style>
